
import {
    CORE_GET_ALL_DEVICE_REQUEST,
    CORE_GET_ALL_DEVICE_SUCCESS,
    CORE_GET_ALL_DEVICE_FAILURE,

    CORE_GET_DEVICE_BY_PLANTCODE_REQUEST,
    CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS,
    CORE_GET_DEVICE_BY_PLANTCODE_FAILURE,

    CORE_CHANGE_IMG_DEVICE_REQUEST,
    CORE_CHANGE_IMG_DEVICE_SUCCESS,
    CORE_CHANGE_IMG_DEVICE_FAILURE,

    CORE_GET_DEVICE_GET_KPI_REQUEST,
    CORE_GET_DEVICE_GET_KPI_SUCCESS,
    CORE_GET_DEVICE_GET_KPI_FAILURE,

    CORE_GET_DEVICE_GET_KPI_DAY_REQUEST,
    CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS,
    CORE_GET_DEVICE_GET_KPI_DAY_FAILURE,

    CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST,
    CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS,
    CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE,

    CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST,
    CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS,
    CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE,
} from '../types'
import { REQUEST_STATE } from '../types';
const requestState = REQUEST_STATE;

export default {
    allDevice: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_ALL_DEVICE_REQUEST:
                return state;
            case CORE_GET_ALL_DEVICE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                }
            case CORE_GET_ALL_DEVICE_FAILURE:
                return [];
            default:
                return state;
        }
    },

    loadDeviceByPlantCode: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_BY_PLANTCODE_REQUEST:
                return state;
            case CORE_GET_DEVICE_BY_PLANTCODE_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_BY_PLANTCODE_FAILURE:
                return [];
            default:
                return state;
        }
    },

    deviceChangeImg: (state = requestState, action) => {
        switch (action.type) {
            case CORE_CHANGE_IMG_DEVICE_REQUEST:
                return state;
            case CORE_CHANGE_IMG_DEVICE_SUCCESS:
                if (action.payload) {
                    const { result, data } = action.payload;
                    if (result && data) {
                        return data;
                    } else return {};
                } else {
                    return {};
                }
            case CORE_CHANGE_IMG_DEVICE_FAILURE:
                return {};
            default:
                return state;
        }
    },

    loadDeviceGetKPI: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_GET_KPI_REQUEST:
                return state;
            case CORE_GET_DEVICE_GET_KPI_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_GET_KPI_FAILURE:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIDay: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_GET_KPI_DAY_REQUEST:
                return state;
            case CORE_GET_DEVICE_GET_KPI_DAY_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_GET_KPI_DAY_FAILURE:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIMonth: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_GET_KPI_MONTH_REQUEST:
                return state;
            case CORE_GET_DEVICE_GET_KPI_MONTH_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_GET_KPI_MONTH_FAILURE:
                return [];
            default:
                return state;
        }
    },
    loadDeviceGetKPIYear: (state = requestState, action) => {
        switch (action.type) {
            case CORE_GET_DEVICE_GET_KPI_YEAR_REQUEST:
                return state;
            case CORE_GET_DEVICE_GET_KPI_YEAR_SUCCESS:
                if (action.payload) {
                    const { result, datas } = action.payload;
                    if (result && datas) {
                        return datas;
                    } else return [];
                } else {
                    return [];
                } case CORE_GET_DEVICE_GET_KPI_YEAR_FAILURE:
                return [];
            default:
                return state;
        }
    },



}


// WEBPACK FOOTER //
// ./src/app/redux/reducers/reducerDeviceAPI.js